<script>
// Ícone de linha de gráfico (Financial Planning). Reconstruído como polyline
// com stroke + nós (circles) — diferente do glifo preenchido do MDI — para
// permitir a animação de "desenhar a linha" (stroke-dashoffset) na navbar.
// Geometria fiel ao mdi-chart-timeline-variant: zigzag ascendente com 4 nós.
export default {
  name: 'MdiChartTimelineVariant',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polyline
      class="chart-line"
      points="3,16 10,8.5 15,14 21,8"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle class="chart-node" cx="3" cy="16" r="1.7" :fill="color" />
    <circle class="chart-node" cx="10" cy="8.5" r="1.7" :fill="color" />
    <circle class="chart-node" cx="15" cy="14" r="1.7" :fill="color" />
    <circle class="chart-node" cx="21" cy="8" r="1.7" :fill="color" />
  </svg>
</template>
